import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { closeCircularProgress, openCircularProgress } from "../uireducers/progress";
import { generateID } from "../../utils/common";
import moment from "moment";
import axios from "axios";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Async Thunks
export const getAllTemplates = createAsyncThunk(
  "formBuilderEntity/getAllTemplates",
  async (_, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const token = localStorage.getItem("userToken");
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(`${API_BASE_URL}/templates`, { headers });
      return response.data;
    } catch (error) {
      console.error("Error fetching templates:", error);
      return thunkAPI.rejectWithValue("Failed to fetch templates");
    } finally {
      thunkAPI.dispatch(closeCircularProgress());
    }
  }
);

export const getSingleTemplate = createAsyncThunk(
  "formBuilderEntity/getSingleTemplate",
  async (data, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const token = localStorage.getItem("userToken");
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(`${API_BASE_URL}/templates/${data}`, { headers });
      return response.data;
    } finally {
      thunkAPI.dispatch(closeCircularProgress());
    }
  }
);

// export const getAllPublishTemplates = createAsyncThunk(
//   "formBuilderEntity/getAllPublishTemplates",
//   async (_, thunkAPI) => {
//     thunkAPI.dispatch(openCircularProgress());
//     try {
//       const token = localStorage.getItem("userToken");
//       const headers = { Authorization: `Bearer ${token}` };
//       const response = await axios.get(`${API_BASE_URL}/templates/publish`, { headers });
//       return response.data;
//     } finally {
//       thunkAPI.dispatch(closeCircularProgress());
//     }
//   }
// );

export const getAllPublishTemplates = createAsyncThunk(
  "formBuilderEntity/getAllPublishTemplates",
  async ({ searchString, page }, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const token = localStorage.getItem("userToken");
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(`${API_BASE_URL}/templates/publish`, { searchString, page }, { headers });
      if (response?.data?.status === "JWT_INVALID") {
        window.location.href = "/";
        return []
      }
      return response.data;
    } finally {
      thunkAPI.dispatch(closeCircularProgress());
    }
  }
);

export const getAllUserList = createAsyncThunk(
  "formBuilderEntity/getAllUserList",
  async (data, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const token = localStorage.getItem("userToken");
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(`${API_BASE_URL}/user/get-user-list`, data, { headers });
      return response.data;
    } finally {
      thunkAPI.dispatch(closeCircularProgress());
    }
  }
);
export const getAllResponses = createAsyncThunk(
  "formBuilderEntity/getAllResponses",
  async (data, thunkAPI) => {
    // Open the Circular Progress
    thunkAPI.dispatch(openCircularProgress());

    try {
      let payload = {
        formId: data
      }
      // Retrieve the token from localStorage
      const token = localStorage.getItem("userToken");

      // Set up the headers with the token
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.post(`${API_BASE_URL}/user-responses/users`, payload, { headers });
      return response.data;
    } finally {
      thunkAPI.dispatch(closeCircularProgress());
    }
  }
);
export const getAllUserTemplates = createAsyncThunk(
  "formBuilderEntity/getAllUserTemplates",
  // async (data, thunkAPI) => {
  //   thunkAPI.dispatch(openCircularProgress());
  //   try {
  //     const token = localStorage.getItem("userToken");
  //     const headers = { Authorization: `Bearer ${token}` };
  //     const response = await axios.post(`${API_BASE_URL}user/get-user-list`, data, { headers });
  //     return response.data;
  //   } finally {
  //     thunkAPI.dispatch(closeCircularProgress());
  //   }
  // }
);

export const addTemplate = createAsyncThunk(
  "formBuilderEntity/addTemplate",
  async (data, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      // Set up headers with authorization
      const token = localStorage.getItem("userToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": data.isFileAttached ? "multipart/form-data" : "application/json"  // Ensure multipart form data is properly handled
      };

      // Send the template to the backend
      const response = await axios.post(`${API_BASE_URL}/templates?isFileAttached=${data.isFileAttached}`, data.formData, { headers });
      return response.data;

    } catch (error) {
      console.log("error", error);

    }
    finally {
      thunkAPI.dispatch(closeCircularProgress());
    }
  }
);



export const deleteTemplate = createAsyncThunk(
  "formBuilderEntity/deleteTemplate",
  async (data, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const token = localStorage.getItem("userToken");
      const headers = { Authorization: `Bearer ${token}` };
      await axios.delete(`${API_BASE_URL}/templates/${data}`, { headers });
      return data;
    } finally {
      thunkAPI.dispatch(closeCircularProgress());
    }
  }
);

export const cloneTemplate = createAsyncThunk(
  "formBuilderEntity/cloneTemplate",
  async (data, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const token = localStorage.getItem("userToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": data?.isFileAttached ? "multipart/form-data" : "application/json" // Ensure multipart form data is properly handled
      };

      const response = await axios.post(`${API_BASE_URL}/templates/clone/${data?.id}?isFileAttached=${data?.isFileAttached}`, data.formData, { headers });

      if (response) {
        window.location.reload();
        return response.data; // Ensure you're returning the correct data
      }
    } finally {
      thunkAPI.dispatch(closeCircularProgress());
    }
  }
);


export const saveTemplate = createAsyncThunk(
  "formBuilderEntity/saveTemplate",
  async (data, thunkAPI) => {
    thunkAPI.dispatch(openCircularProgress());
    try {
      const token = localStorage.getItem("userToken");
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.put(`${API_BASE_URL}/templates/${data.id}`, data, { headers });
      return response.data;
    } finally {
      thunkAPI.dispatch(closeCircularProgress());
    }
  }
);

// Slice
const slice = createSlice({
  name: "formBuilderEntity",
  initialState: {
    allTemplates: [],
    selectedTemplate: null,
    getAllPublishTemplates: [],
    getAllUserList: [],
    getAllUserTemplates: [],
    getAllResponses: [],
  },
  reducers: {
    setSelectedTemplateNull: (state) => {
      state.selectedTemplate = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTemplates.fulfilled, (state, action) => {
      state.allTemplates = action.payload;
    });
    builder.addCase(getAllPublishTemplates.fulfilled, (state, action) => {
      state.getAllPublishTemplates = action.payload;
    });
    builder.addCase(getAllUserList.fulfilled, (state, action) => {
      state.getAllUserList = action.payload;
    });
    builder.addCase(getAllResponses.fulfilled, (state, action) => {
      state.getAllResponses = action.payload;
    });
    builder.addCase(getAllUserTemplates.fulfilled, (state, action) => {
      state.getAllUserTemplates = action.payload;
    });
    builder.addCase(getSingleTemplate.fulfilled, (state, action) => {
      state.selectedTemplate = action.payload;
    });
    builder.addCase(addTemplate.fulfilled, (state, action) => {
      state.allTemplates.push(action.payload);
    });
    builder.addCase(saveTemplate.fulfilled, (state, action) => {
      const index = state.allTemplates.findIndex((t) => t.id === action.payload.id);
      if (index !== -1) state.allTemplates[index] = action.payload;
    });
    builder.addCase(deleteTemplate.fulfilled, (state, action) => {
      state.allTemplates = state.allTemplates.filter((t) => t.id !== action.payload);
    });
    builder.addCase(cloneTemplate.fulfilled, (state, action) => {
      state.allTemplates = state.allTemplates.filter((t) => t.id !== action.payload);
    });
  },
});

export const { setSelectedTemplateNull } = slice.actions;

export default slice.reducer;
